import React from "react";

import "./PlasticLife.scss";

import first from "./assets/img/1.png";
import second from "./assets/img/2.png";
import third from "./assets/img/3.png";
import fourth from "./assets/img/4.png";

const PlasticLife = () => {
  return (
    <section className="plastic">
      <div className="container">
        <div className="plastic-wrapper">
          <h2 className="section-title plastic__title">
            Вторая жизнь пластика
          </h2>

          <span className="plastic__subtitle">
            Что из него можно сделать после переработки?
          </span>

          <div className="plastic-cards">
            <div
              className="plastic__card"
              style={{ backgroundImage: `url(${first})` }}
              id="first"
            >
              <div className="plastic__card-info">
                <span className="plastic__card-info__title">
                  Футуристичная мебель
                </span>
                <a
                  href="https://www.instagram.com/p/CTxGLDoM9Ch/ "
                  className="button button--outlined plastic__card-info__button"
                >
                  Подробнее
                </a>
              </div>
            </div>
            <div
              className="plastic__card"
              style={{ backgroundImage: `url(${second})` }}
              id="second"
            >
              <div className="plastic__card-info">
                <span className="plastic__card-info__title">
                  Забавные арт-объекты
                </span>
                <a
                  href="https://kulturologia.ru/blogs/130510/12466/ "
                  className="button button--outlined plastic__card-info__button"
                >
                  Подробнее
                </a>
              </div>
            </div>
            <div
              className="plastic__card"
              style={{ backgroundImage: `url(${third})` }}
              id="third"
            >
              <div className="plastic__card-info">
                <span className="plastic__card-info__title">
                  Стильные украшения
                </span>
                <a
                  href="https://www.instagram.com/p/CRoBrGVLVYj/ "
                  className="button button--outlined plastic__card-info__button"
                >
                  Подробнее
                </a>
              </div>
            </div>
            <div
              className="plastic__card"
              style={{ backgroundImage: `url(${fourth})` }}
              id="fourth"
            >
              <div className="plastic__card-info">
                <span className="plastic__card-info__title">
                  Тротуарная плитка
                </span>
                <a
                  href="https://recyclemag.ru/news/perekryostok--zapustili-proekt-pererabotke-zubnih-schyotok "
                  className="button button--outlined plastic__card-info__button"
                >
                  Подробнее
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlasticLife;
